import { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { useRecentlyViewed } from '../contexts/RecentlyViewedContext';
import { repository } from '../lib/repository';

/**
 * RecentlyViewed — reads slugs from context, resolves to products via the repository,
 * and renders as a horizontal-scrolling rail (mobile) / grid (desktop).
 * Optionally excludes a given slug (used on PDP so we don't show the piece you're on).
 */
export default function RecentlyViewed({ excludeSlug, title = 'Recently Viewed', eyebrow = 'For you', limit = 4 }) {
  const { slugs } = useRecentlyViewed();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const filtered = slugs.filter((s) => s !== excludeSlug).slice(0, limit);
    if (!filtered.length) { setItems([]); return; }
    Promise.all(filtered.map((s) => repository.getProduct(s))).then((res) => setItems(res.filter(Boolean)));
  }, [slugs, excludeSlug, limit]);

  if (items.length === 0) return null;

  return (
    <section data-testid="recently-viewed" className="container py-24 md:py-32 border-t border-border">
      <div className="mb-10">
        <p className="overline text-muted-foreground">{eyebrow}</p>
        <h2 className="mt-3 font-display text-4xl md:text-5xl">{title}</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-12 md:gap-x-6">
        {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </section>
  );
}
